import { ChainID, ChainPath } from '@ankr.com/chains-list';

export const mapSharkChainToChainPath = (chainPath: ChainPath) => {
  switch (chainPath) {
    case 'aapi_v2':
      return ChainID.MULTICHAIN as ChainPath;
    case 'klaytn':
      return ChainID.KAIA as ChainPath;
    case 'klaytn_testnet':
      return ChainID.KAIA_TESTNET as ChainPath;
    default:
      return chainPath;
  }
};
